import * as React from "react";
import { CheckboxEditor } from "../../../../../../react-core/Html/CheckboxEditor";
import { RadiosEditor } from "../../../../../../react-core/Html/RadiosEditor";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { SectionHeader } from "../SharedComponents";

interface IPaperLessProps extends IProcessComponentProps {
    readOnly: boolean;
}

interface IPaperLessState {
    termsConfirmed: boolean;
}

export class PaperLess extends ProcessComponent<IPaperLessProps, IPaperLessState> {
    constructor(props: any) {
        super(props);
        this.state = {
            termsConfirmed: false,
        };
    }

    componentDidMount() {
        super.componentDidMount();
        const { data, readOnly, onChange } = this.props;
        if (data?.PaperLess) {
            this.setState({ termsConfirmed: true });
        }
        //if creating subaccount, then keep headaccount setting
        if (readOnly && data?.ExistingAccountPaperLess != null) {
            this.onDataChange(onChange, { PaperLess: data?.ExistingAccountPaperLess }, data);
            if (data?.ExistingAccountPaperLess) {
                this.setState({ termsConfirmed: true });
            }
        }
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        if (prevProps.readOnly != this.props.readOnly) {
            const { data, readOnly, onChange } = this.props;
            if (readOnly && data?.ExistingAccountPaperLess != null) {
                //if switching from creating new account to create subaccount, use existing account settings
                this.onDataChange(onChange, { PaperLess: data?.ExistingAccountPaperLess }, data);
                if (data?.ExistingAccountPaperLess) {
                    this.setState({ termsConfirmed: true });
                }
            } else {
                //if switching from creating sub account to create new account, set paperless to default (false)
                this.onDataChange(onChange, { PaperLess: false }, data);
            }
        }
    }

    public render(): JSX.Element {
        const { data, onChange, readOnly } = this.props;
        return (
            <>
                <h2 className="mb-22">Paperless preference</h2>
                <RadiosEditor
                    cssWrapper="radio-group rg-inline rg-150 mb-23"
                    selected={data?.PaperLess}
                    options={[true, false]}
                    label={"Go paperless"}
                    getText={(v) => (v ? "Yes" : "No")}
                    onChange={(v) => {
                        this.onDataChange(onChange, { PaperLess: v }, data);
                        this.setState({ termsConfirmed: false });
                    }}
                    required="Please select"
                    disabled={readOnly}
                />
                <p>
                    There are certain documents which for legal or regulatory reasons must still be sent directly to the
                    customer. All documents can be accessed from the client's document library
                </p>
                {data?.PaperLess && (
                    <CheckboxEditor
                        required={"You must tick the declaration checkbox when selecting Yes to Go Paperless"}
                        label="I confirm I have received instruction from my client(s) to manage their correspondence on their behalf and will ensure that this information is passed onto my client(s). I am able to provide evidence of my client(s) instruction on Aberdeen request"
                        cssWrapper="control-size-60 square-checkbox"
                        value={this.state.termsConfirmed}
                        onChange={(v) => {
                            this.setState({ termsConfirmed: v });
                        }}
                    ></CheckboxEditor>
                )}
            </>
        );
    }
}
